// Quick-reply drafts: what someone has typed in reply to a message, keyed by the delivery's id (a
// newer message refreshes the delivery in place and keeps its id, so the draft survives it). In
// memory for the page session, like the toasts already announced (`delivery-seen.ts`): closing a
// toast keeps the draft for the same message's card on My tasks; a sent reply spends it.
const drafts = new Map<string, string>();

export function replyDraft(deliveryId: string): string {
  return drafts.get(deliveryId) ?? '';
}

/** Keep `text` for this delivery; a blank draft is forgotten. */
export function keepReplyDraft(deliveryId: string, text: string) {
  if (text.trim() === '') drafts.delete(deliveryId);
  else drafts.set(deliveryId, text);
}

export function spendReplyDraft(deliveryId: string) {
  drafts.delete(deliveryId);
}

/** Forget every draft (specs only). */
export function resetReplyDrafts() {
  drafts.clear();
}
